import { Routes, Route } from "react-router-dom";

import TripListScreen from "screens/App/CRM/Trip/TripListScreen";
import TripDetailScreen from "screens/App/CRM/Trip/TripDetailScreen";
import TripEditScreen from "screens/App/CRM/Trip/TripEditScreen";
import TripCreateScreen from "screens/App/CRM/Trip/TripCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const TripRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<TripListScreen />} />
      <Route path="create" element={<TripCreateScreen />} />
      <Route path=":id/detail" element={<TripDetailScreen />} />
      <Route path=":id/edit" element={<TripEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default TripRouter;